import {
  INIT_URL,
  SIGNOUT_USER_SUCCESS, 
  USER_TOKEN_SET,
  TYPE_USER_SET,
  TYPE_USER_HOSPITAL_SET,
  USER_INFO_SET,
  REQUEST_DELETE_ACCOUNT_SUCCESS,
  REQUEST_DELETE_ACCOUNT_ERROR
} from "../constants/ActionTypes";

const INIT_STATE = {
  token: localStorage.getItem('mhc'),
  initURL: '',
  userType: -1,
  userInfo: {},
  hospital_id: null,
  deleteAccountStatus: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        userType: -1,
        initURL: '',
        hospital_id: null
      }
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }
    case TYPE_USER_SET: {
      return {
        ...state,
        userType: action.payload
      }
    }
    case USER_INFO_SET: {
      return {
        ...state,
        userInfo: action.payload
      }
    }
    case TYPE_USER_HOSPITAL_SET:{
      return {
        ...state,
        hospital_id: action.payload.hospital_id
      }
    }
    case REQUEST_DELETE_ACCOUNT_SUCCESS:{
      return {
        ...state,
        deleteAccountStatus: true
      }
    }
    case REQUEST_DELETE_ACCOUNT_ERROR:{
      return {
        ...state,
        deleteAccountStatus: false
      }
    }

    default:
      return state;
  }
}
